import { type IBaseWorkflowData } from 'entities/Workflow'
import type { IParamsFiltersList } from 'entities/Broadcast/api/types'
import type { IResponseFilterSegment } from 'entities/Segment'

function isIResponseFilterSegment(
  item: IParamsFiltersList | IResponseFilterSegment[]
): item is IResponseFilterSegment[] {
  return Array.isArray(item)
}

const emptyFilters: IParamsFiltersList = {
  contacts: [],
  tags: [],
  segments: [],
  advanced: [],
}

export const transformWorkflowV1TriggerArgsToV2 = (
  args: IBaseWorkflowData['definition']['trigger']['args']
): {
  filters: IParamsFiltersList
  excludeFilters: IParamsFiltersList
} => {
  const filters = args?.filters || emptyFilters

  if (isIResponseFilterSegment(filters)) {
    return {
      filters: {
        ...emptyFilters,
        advanced: [
          {
            filtersList: filters,
          },
        ],
      },
      excludeFilters: emptyFilters,
    }
  } else {
    const excludeFilters =
      !!args && 'excludeFilters' in args && args.excludeFilters ? args.excludeFilters : emptyFilters

    return {
      filters: filters,
      excludeFilters: excludeFilters,
    }
  }
}
